import {Button, Container, Typography} from "@material-ui/core";
import BugFixing from '../assets/undraw_bug_fixing.svg';

export default function ErrorPage() {
    return (
        <Container maxWidth="md" style={{textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 32px)'}}>
            <img src={BugFixing} style={{maxHeight: 400, maxWidth: '100%'}} alt="bugFixIcon" />
            <Typography variant="h3" gutterBottom>Aaaah! Something went wrong </Typography>
            <Typography variant="h5">Brace yourself till we get the error fixed.</Typography>
            <Typography variant="h5" gutterBottom>You may also refresh the page or try again later</Typography>
            <Typography variant="h5" gutterBottom>Contact us : support@mazingday.com</Typography>
            <Button variant="contained" color="primary" href="https://mazingday.com/">Go Home</Button>
        </Container>
    );
}
